export const PARTNER_VALIDATION = {
  name_min_length: 1,
  name_max_length: 50,
  mobile_min_length: 1,
  mobile_regex: /^[6-9]\d{9}$/,
} as const;

export const PARTNER_STORE = {
  isd_code: '+91',
  phablet_size: 559,

  getPartnerAppTitle: 'GET PARTNER APP',
  name_error_msg: 'Enter the name',
  mobile_error_msg: 'Enter mobile number',
  city_error_msg: 'Please select a city',
  vehicle_error_msg: 'Please select a vehicle',
  source_error_msg: 'This field is required',

  ack_msg: 'THANK YOU FOR REGISTRATION',
  ack_desc: 'We will get back to you shortly',
  req_msg: 'Register More',
  app_download_link: 'https://app.adjust.com/1l1fw2j2?engagement_type=fallback_click',

  ga_download_porter_click: ' App Download/<Click>',

  loading_vehicles: 'Laoding Vehicles...',
  try_again: 'Something went wrong. Try Again...',

  attach_vehicle_title: 'Attach Vehicle Now',
  loading_text: 'Loading...',
  register_btn: 'REGISTER',
  name_placeholder: 'Enter your name',
  mobile_placeholder: 'Enter mobile number',
  city_placeholder: 'Select City',
  vehicle_placeholder: 'Select Vehicle',
  vehicle_placeholder_caps: 'SELECT VEHICLE',
  source_placeholder: 'WHERE DID YOU HEAR ABOUT US?',
} as const;
